import { useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const Confirm = () => {

    // functions from App component
    // to transit values of JWT and errors to App component
    const { setAlertClassName } = useOutletContext();
    const { setAlertMessage } = useOutletContext();
    const { token } = useParams();

    const navigate = useNavigate();

    useEffect(() => {

        const headers = new Headers();
        headers.append("Content-Type", "application/json");


        let method = "GET";

        let requestOptions = {
            method: method,
            headers: headers,
        }

        // make a request
        fetch(`${process.env.REACT_APP_BACKEND}/api/confirm-account/${token}`, requestOptions)
            // convert response to json 
            .then((response) => response.json())
            .then((data) => {
                // if there IS an error 
                if (data.error) {
                    setAlertClassName("alert-danger"); // show error class
                    setAlertMessage(data.message);
                } else { // if there is NO error
                    setAlertClassName("d-none"); // hide alert if it was
                    setAlertMessage("");
                    Swal.fire({ // message to confirm email
                        title: 'Confirmed!',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    })
                    navigate("/");
                }
            })
            // if there is an unexpected error
            .catch(error => {
                    setAlertClassName("alert-danger");
                    setAlertMessage(error);
                })

    });

    return (
        <div>
        </div>
    )
}

export default Confirm;